import { render } from "./ConsultWorkerPage.vue?vue&type=template&id=18225fca&ts=true"
import script from "./ConsultWorkerPage.vue?vue&type=script&lang=ts"
export * from "./ConsultWorkerPage.vue?vue&type=script&lang=ts"

import "./ConsultWorkerPage.vue?vue&type=style&index=0&id=18225fca&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__